import React from 'react';
import styles from './MatrixPageHeader.scss';

function MatrixPageHeader() {
  // for local img display ->  http://localhost:8080/svgs/racing_post_plus_logo.svg
  return (
    <div className={styles.root}>
      <div className={styles.headerImage}>
        <img
          src="/svgs/racing_post_plus_logo.svg"
          className={styles.logo}
          alt="racing post plus logo"
                />
      </div>
    </div>
  );
}

export default MatrixPageHeader;
